import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from "react";
import { Skeleton, Image as MantineImage } from "@mantine/core";
import { BlobWriter, getMimeType } from "@zip.js/zip.js";
const ZipImage = ({ image, maxWidth, maxHeight, isAnimation }) => {
    const [imageUrl, setImageUrl] = useState(undefined);
    useEffect(() => {
        let isMounted = true;
        const readImage = async () => {
            const mimeType = getMimeType(image.filename);
            const blob = await image.getData(new BlobWriter(mimeType));
            const img = new Image();
            const originalURL = URL.createObjectURL(blob);
            img.src = originalURL;
            img.onload = () => {
                if (!isMounted) {
                    return;
                }
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                // Resizes the image to fit within the maximum width and height while maintaining its aspect ratio.
                let { width, height } = img;
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
                canvas.width = width;
                canvas.height = height;
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, width, height);
                URL.revokeObjectURL(originalURL);
                if (isMounted) {
                    canvas.toBlob((blob) => {
                        if (blob) {
                            const objectURL = URL.createObjectURL(blob);
                            setImageUrl(objectURL);
                        }
                    }, mimeType);
                }
            };
        };
        readImage();
        return () => {
            isMounted = false;
            if (imageUrl) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [image, maxWidth, maxHeight]);
    if (!imageUrl) {
        return _jsx(Skeleton, { h: maxHeight, w: maxWidth });
    }
    if (isAnimation) {
        console.log({ isAnimation });
        console.log(imageUrl);
        return (_jsx("video", { controls: true, loop: true, playsInline: true, width: "100%", children: _jsx("source", { src: imageUrl }) }));
    }
    return (_jsx(MantineImage, { src: imageUrl, height: maxHeight, width: maxWidth, fit: "contain" }));
    // return <MantineImage src={imageUrl} maw={maxWidth} mah={maxHeight} />;
};
export default ZipImage;
